import { combineReducers } from "redux-immutable";

import SectionStatStateSlice from "../../models/state/sectionStats";
import { sectionStatsMeta } from "./state/meta";
import { sectionStats } from "./state/stats";

export default combineReducers(
  {
    meta: sectionStatsMeta,
    stats: sectionStats
  },
  () => new SectionStatStateSlice() as any
);
